import React from 'react'
import { Checkbox, FormControlLabel, Link as MuiLink } from '@mui/material'
import { BAA_AGREEMENT_TEXT } from './baa-agreement-text'
import config from '../common/config'

function BaaAgreementPanel(props: {
  isAccepted: boolean
  onAcceptedChange: (isAccepted: boolean) => void
  isSubmitting?: boolean
}) {
  const { isAccepted, onAcceptedChange, isSubmitting } = props

  return (
    <div className="space-y-3">
      <div className="max-h-64 overflow-y-auto rounded-md border border-gray-300 bg-gray-50 p-4 text-sm text-gray-700 whitespace-pre-wrap">
        {BAA_AGREEMENT_TEXT}
      </div>

      <p className="text-sm text-gray-500">
        You may also request a signed PDF by emailing{' '}
        <a href="mailto:support@notezap.com" className="text-blue-600 hover:underline">
          support@notezap.com
        </a>
        .
      </p>

      <div className="text-sm text-gray-600">
        {config.privacyPolicyUrl && (
          <>
            Read our{' '}
            <MuiLink href={config.privacyPolicyUrl} target="_blank" rel="noopener noreferrer">
              privacy policy
            </MuiLink>
            {config.termsOfServiceUrl ? ' and ' : '.'}
          </>
        )}
        {config.termsOfServiceUrl && (
          <>
            <MuiLink href={config.termsOfServiceUrl} target="_blank" rel="noopener noreferrer">
              terms of service
            </MuiLink>
            .
          </>
        )}
      </div>

      <FormControlLabel
        control={
          <Checkbox
            checked={isAccepted}
            onChange={e => onAcceptedChange(e.target.checked)}
            disabled={isSubmitting}
          />
        }
        label="I have read and agree to the Business Associate Agreement."
      />
    </div>
  )
}

export default BaaAgreementPanel
